import React, { useMemo } from 'react';
import {
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgressProps,
} from '@mui/material';

export interface CustomButtonProps extends MuiButtonProps {
  isLoading?: boolean;
  circularProgressProps?: CircularProgressProps;
}

export const Button = ({
  children,
  isLoading,
  circularProgressProps,
  ...muiProps
}: CustomButtonProps) => (
  <MuiButton {...muiProps}>
    {isLoading ? (
      <CircularProgress aria-hidden color="inherit" {...circularProgressProps} />
    ) : (
      children
    )}
  </MuiButton>
);
